module.exports = __webpack_public_path__ + "static/media/Itellect_Simon JV_white.b4880a77.png";